import {RequestOptions} from "@web-libs/core/http/api/http.types";
import baseUrl from "@web-libs/core/http/infrastructure/server-side/_base-url";
import noCache from "@web-libs/core/http/infrastructure/server-side/_no-cache";
import {resolveTags} from "@web-libs/core/tags/api/tag-resolving";
import {with_, withDeep} from "@web-libs/util/with/with";
import {buildFetchFunction} from "@web-libs/core/http/infrastructure/shared/build-fetch-function";
import {RequestInitTransformer} from "@web-libs/core/http/infrastructure/shared/_build_fetch_options";

const buildTags: RequestInitTransformer = (requestInit:RequestInit,requestOptions?: RequestOptions) => {
    const tags = resolveTags(requestOptions?.tags, requestOptions?.tenantId)
    return withDeep(requestInit, 'next', {tags})
}

const disableCache: RequestInitTransformer = (requestInit:RequestInit, _) => {
    return with_(requestInit, {cache: 'no-cache'})
}

const transformer = []
if(noCache) transformer.push(disableCache)

export const _fetch = buildFetchFunction(baseUrl!, transformer)


